import * as React from 'react';
import { UitkTextInput } from 'uitk-react-input';
import { ClickTracker } from 'bernie-analytics';

const TrackedTextInput = ClickTracker(UitkTextInput);

export const ReviewEntry = ({ listClasses, l10n, onFocus }) => (
  <div className={listClasses}>
    <div className=".uitk-grid.all-cell-1-1">
      <TrackedTextInput
        onFocus={onFocus}
        value=""
        label={l10n.formatText('hotels.infosite.findAnswers.cta.reviews.placeholder')}
        placeholder={l10n.formatText('hotels.infosite.findAnswers.cta.reviews.placeholder')}
        id="findAnswerReviewEntry"
        icon="search"
        name="findAnswerReviewEntry"
        hasVisibleLabel={false}
        linkName="Open from ReviewEntry"
        rfrr="AskQuestion.FindAnswersReviewEntry"
      />
    </div>
  </div>
);

ReviewEntry.displayName = 'ReviewEntry';
